module.exports = __webpack_public_path__ + "img/home-brands-mulino-bianco.jpg?40cbc500bf2eb18e3b1fd67ae38e88ba";